// BOT-1422. 'list' is one product per full-width row - what scales to the 7 upsells the busiest
// stores configure - and 'grid' is Mark's 2x2.
export const UPSELL_LAYOUTS = ['list', 'grid']

const DEFAULT_LAYOUT = 'grid'

// `?upsell_layout=list` lets both designs be compared on one build, the same escape hatch
// version_2 gives its interface. Anything we do not recognise is someone else's query param, not
// an instruction.
export function upsellLayoutFromQuery(query) {
  const value = query?.upsell_layout
  return UPSELL_LAYOUTS.includes(value) ? value : null
}

export function resolveUpsellLayout(override) {
  return UPSELL_LAYOUTS.includes(override) ? override : DEFAULT_LAYOUT
}
